import { selectTutorialConfig } from "../../../../selectors/selectTutorial";
import { utilProduction } from "../../../../utils/utilProduction";
import { IdTutorialStep } from "../../IdTutorialStep";
export var checkTutorialStepIsSelectRecipe = function (path) { return function (action, state$, dependencies) {
    // TODO: use switch action.tutorialStep
    if (action.tutorialStep === IdTutorialStep.sowWildflowers_clickOnRecipe) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.produceChickenFeed_clickStartProduction) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.checkNewQuest_clickStartProduction) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.sowWildflowers_clickStartProduction) {
        var produceWildflowersStep = selectTutorialConfig(state$.value, IdTutorialStep.sowWildflowers_clickAcre);
        // This is necessary for recipe select on sow windflower tutorial step
        utilProduction.setProductionRecipe(1, produceWildflowersStep.buildingId);
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/checks/checkTutorialStepIsSelectRecipe.ts
// module id = 2472
// module chunks = 3